import { render, staticRenderFns } from "./unificacion.vue?vue&type=template&id=2b71c650&scoped=true"
import script from "./unificacion.vue?vue&type=script&lang=js"
export * from "./unificacion.vue?vue&type=script&lang=js"
import style0 from "./unificacion.vue?vue&type=style&index=0&id=2b71c650&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b71c650",
  null
  
)

export default component.exports